export default "__VITE_ASSET__BXkXkw9G__"